"use client"

import VariantsRow from "~/components/ui/ProductHeader/components/ProductDetails/components/VariantsRow"
import { ClientViewItem } from "~/components/shared/AnalyticsEvents/ClientViewItem/index.client"
import type { VariantsRowWithVariantSwitchProps } from "~/app/[locale]/products/[slug]/(components)/VariantsRowWithVariantSwitch"
import { useVariantSwitch } from "~/app/[locale]/products/[slug]/(hooks)/useVariantSwitch"

function ClientVariantsRowWithVariantSwitch({
  className,
  variants,
  productType,
  stockAlertEnabled,
  sizeGuideDisabled,
  defaultVariant,
  trackingData: _trackingData,
  sizeGuide,
  isInAddToCartPopin,
  withTracking,
  label,
  product,
}: VariantsRowWithVariantSwitchProps) {
  const { activeVariant, onChange } = useVariantSwitch({ variants, defaultVariant })

  return (
    <>
      <VariantsRow
        className={className}
        variants={variants}
        defaultVariant={defaultVariant}
        onChange={onChange}
        productType={productType}
        stockAlertEnabled={stockAlertEnabled}
        isInAddToCartPopin={isInAddToCartPopin}
        sizeGuideDisabled={sizeGuideDisabled}
        sizeGuide={sizeGuide}
        label={label}
      />
      {withTracking && <ClientViewItem activeVariant={activeVariant} product={product} />}
    </>
  )
}

export default ClientVariantsRowWithVariantSwitch
